import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaymentMethod } from "src/models/Prices/PaymentMethod.models";

interface PaymentMethodState {
  paymentMethods: IPaymentMethod[];
  paymentMethodToEdit: IPaymentMethod | null;
}

const initialState: PaymentMethodState = {
  paymentMethods: [],
  paymentMethodToEdit: null,
};

const PaymentMethodSlice = createSlice({
  name: "PaymentMethod",
  initialState,
  reducers: {
    setPaymentMethodList: (state, action: PayloadAction<IPaymentMethod[]>) => {
      state.paymentMethods = action.payload;
    },
    setPaymentMethodToEdit: (
      state,
      action: PayloadAction<IPaymentMethod | null>
    ) => {
      state.paymentMethodToEdit = action.payload;
    },
    concatListPaymentMethod: (
      state: PaymentMethodState,
      action: PayloadAction<IPaymentMethod[]>
    ) => {
      state.paymentMethods = [...state.paymentMethods.concat(action.payload)];
    },
    addPaymentMethod: (state, action: PayloadAction<IPaymentMethod>) => {
      state.paymentMethods.push(action.payload);
    },
    updatePaymentMethod: (state, action: PayloadAction<IPaymentMethod>) => {
      let itemIndex = state.paymentMethods.findIndex(
        item => item.paymentMethodId === action.payload.paymentMethodId
      );
      if (itemIndex !== -1) state.paymentMethods[itemIndex] = action.payload;
    },
    deletePaymentMethod: (state, action: PayloadAction<number>) => {
      const newArray = state.paymentMethods.filter(
        item => item.paymentMethodId !== action.payload
      );
      state.paymentMethods = newArray;
    },
  },
});

export const {
  setPaymentMethodList,
  concatListPaymentMethod,
  setPaymentMethodToEdit,
  addPaymentMethod,
  updatePaymentMethod,
  deletePaymentMethod,
} = PaymentMethodSlice.actions;

export default PaymentMethodSlice.reducer;
